<template>
  <div>
    <header>
      <div class="container">
        <div class="row">
          <div class="col-4">
            <div class="branding">
              <router-link
                :to="{ name: 'home' }"
                class="branding__mark d-inline-block align-top"
              >
                <img
                  height="50"
                  alt="Microba"
                  src="/assets/images/Logo-navy-blue.png"
                >
              </router-link>
              <span
                class="branding__title align-top d-none d-md-inline-block"
              >Practitioner Portal</span>
            </div>
          </div>
          <div class="col-8">
            <div class="admin-toolbar float-right">
              <span
                v-if="hcp && user"
                class="d-none d-lg-inline-block"
              >
                logged in as
                <strong
                  @click="userCanImpersonate"
                >{{ user.firstName }} {{ user.lastName }}</strong>
                <widget-admin
                  :show="show"
                  @close="show = false"
                />
              </span>
              <div
                class="btn-group admin-toolbar__menu"
                role="group"
              >
                <div
                  data-cy="my-acc"
                  class="btn-group dropdown"
                  role="group"
                >
                  <button
                    type="button"
                    class="btn btn-secondary dropdown-toggle"
                    href="#"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    My Account
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuLink"
                  >
                    <router-link
                      data-cy="acc-settings"
                      class="dropdown-item"
                      :to="{ name: 'account' }"
                    >
                      Account Settings
                    </router-link>
                  </div>
                </div>
                <a
                  class="btn btn-secondary"
                  href="#"
                  @click.prevent="logout"
                >Log out</a>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ul class="nav justify-content-end main-nav">
              <li class="nav-item">
                <a
                  class="nav-link external-link"
                  target="_new"
                  href="https://www.microba.com/clinical-resources/"
                >Clinical Resources <i class="fas fa-external-link-alt" /></a>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'home' }"
                  class="nav-link"
                >
                  Dashboard
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'patients' }"
                  class="nav-link"
                >
                  Patients
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'referrals' }"
                  class="nav-link"
                >
                  Referrals
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div />
      </div>
    </header>
    <router-view />
    <footer>
      <div class="container">
        <div class="row footer-info">
          <div class="col-12 p-2">
            <div class="row">
              <div class="col-xs-6 p-2">
                <span class="fa-stack fa-2x">
                  <i class="fa fa-circle fa-stack-2x" />
                  <i class="fa fa-phone-volume fa-stack-1x fa-inverse" />
                </span>
              </div>
              <div class="col-xs-6 mt-4">
                <p>
                  Book a time to speak with a Microba expert about your patients
                  results
                  <a
                    href="https://www.microba.com/hcp-support/"
                    target="_blank"
                  >here</a>.
                </p>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6 contact">
            <div class="row">
              <div class="col-xs-12">
                <img
                  class="contact__avatar img-fluid col-xs-6 d-inline-block"
                  width="65"
                  src="/assets/images/icon-coach.svg"
                >
                <div class="col-xs-6 d-inline-block">
                  <h6 class="contact__title">
                    Contact Support
                  </h6>
                  <span class="contact__description">Phone: 1300 974 621</span>
                  <span
                    class="contact__email"
                  ><a
                    href="mailto:healthcare@microba.com"
                  >healthcare@microba.com</a></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6 socmed">
            <h6>Follow Microba</h6>
            <ul class="list-inline">
              <li class="list-inline-item">
                <a
                  href="https://www.facebook.com/MicrobaOfficial/"
                  target="_blank"
                  title="Facebook"
                  class="socmed__link socmed--facebook"
                ><i class="fab fa-facebook-f" /></a>
              </li>
              <li class="list-inline-item">
                <a
                  href="https://twitter.com/MicrobaOfficial"
                  target="_blank"
                  title="Twitter"
                  class="socmed__link socmed--twitter"
                ><i class="fab fa-twitter" /></a>
              </li>
              <li class="list-inline-item">
                <a
                  href="https://www.linkedin.com/company/microba/"
                  target="_blank"
                  title="Linkedin"
                  class="socmed__link socmed--linkedin"
                ><i class="fab fa-linkedin" /></a>
              </li>
              <li class="list-inline-item">
                <a
                  href="https://www.instagram.com/microbaofficial/"
                  target="_blank"
                  title="Youtube"
                  class="socmed__link socmed--youtube"
                ><i class="fab fa-instagram" /></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="row footer-legals justify-content-center">
          <div class="col-xs-12">
            <ul class="list-inline footer-legal">
              <li class="list-inline-item">
                <a
                  :href="termsLink"
                  target="_blank"
                >Terms &amp; Conditions</a>
              </li>
              <li class="list-inline-item">
                <a
                  href="https://discover.microba.com/privacy"
                  target="_blank"
                >Privacy Policy</a>
              </li>
              <li class="list-inline-item">
                &nbsp;&nbsp; © Microba Pty Ltd. 2019
                <span class="versionInfo">
                  {{ versionInfo.tag }}-{{ versionInfo.hash }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>

    <div
      class="modal fade inviteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content pt-3 pb-3">
          <div class="row">
            <div class="col-12 text-center">
              <h3>Refer a Patient</h3>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12 col-md-6 text-center pl-5">
              <div class="row text-center">
                <div class="col-12">
                  Refer via your custom URL
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group mt-3">
                    <input
                      id="userLink"
                      v-model="userLink"
                      class="form-control"
                      readonly
                    >
                  </div>
                </div>
              </div>
              <div class="row text-center">
                <div class="col-12">
                  <span
                    class="clipboard text-orange clickable"
                    data-placement="top"
                    :data-clipboard-text="userLink"
                    data-content="Copy to clipboard"
                    data-original-title=""
                    title=""
                    @click="copyUserURL"
                  >
                    Click here to copy it to the clipboard
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 pr-5">
              <div class="row text-center">
                <div class="col-12">
                  Send a referral email
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group mt-3 mb-1">
                    <input
                      v-model="invite.firstName"
                      v-validate="'required'"
                      name="inviteFirstName"
                      data-vv-scope="inviteForm"
                      :class="{
                        'is-invalid': errors.first('inviteForm.inviteFirstName')
                      }"
                      class="form-control"
                      placeholder="First name"
                    >
                    <div class="invalid-feedback">
                      Please provide a first name
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group mb-1">
                    <input
                      v-model="invite.lastName"
                      v-validate="'required'"
                      name="inviteLastName"
                      data-vv-scope="inviteForm"
                      :class="{
                        'is-invalid': errors.first('inviteForm.inviteLastName')
                      }"
                      class="form-control"
                      placeholder="Last name"
                    >
                    <div class="invalid-feedback">
                      Please provide a last name
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group mb-1">
                    <input
                      v-model="invite.email"
                      v-validate="'required|email'"
                      name="inviteEmail"
                      data-vv-scope="inviteForm"
                      :class="{
                        'is-invalid': errors.first('inviteForm.inviteEmail')
                      }"
                      class="form-control"
                      placeholder="Email"
                    >
                    <div class="invalid-feedback">
                      Please provide a valid email
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group mb-1">
                    <input
                      v-model="invite.phone"
                      name="invitePhone"
                      class="form-control"
                      placeholder="Phone"
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <textarea
                      v-model="invite.notes"
                      name="inviteNotes"
                      class="form-control"
                      placeholder="Message to patient"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <a
                    class="btn btn-primary btn-block"
                    href="#"
                    @click.prevent="sendInvite"
                  >
                    <span v-if="isLoading">
                      <i class="fas fa-spin fa-spinner" />
                    </span>
                    <span v-else>
                      Send Referral
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import $ from 'jquery'
import WidgetAdmin from '@/components/widgets/WidgetAdmin'
import authService from '@/services/authService.js'

// @ is an alias to /src
export default {
  name: 'Page',
  components: {
    WidgetAdmin
  },
  data () {
    return {
      isLoading: false,
      invite: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        notes: ''
      },
      show: false,
      termsLink: process.env.VUE_APP_TERMS_URL
    }
  },
  computed: {
    versionInfo () {
      return {
        tag: process.env.VUE_APP_TAG,
        hash: process.env.VUE_APP_HASH
      }
    },
    userLink () {
      if (this.hcp) {
        return 'https://orders.microba.com/?ref=REF' + this.hcp.referralCode
      }
      return ''
    },
    user: function () {
      return this.$store.state.GET_USER_RESPONSE
    },
    hcp: function () {
      return this.$store.state.GET_HCP_RESPONSE
    },
    kitsComplementary () {
      return this.$store.state.GET_COMP_KITS_WITH_RESULTS_RESPONSE
    },
    newKitsComplementary () {
      return _.filter(this.kitsComplementary, (x) => {
        return !x.transferred
      })
    }
  },
  mounted () {
    this.$store.dispatch('getComplementary')
  },
  methods: {
    logout () {
      this.$store.dispatch('logout', {
        email: this.email,
        password: this.password
      })
    },
    copyUserURL () {
      /* Get the text field */
      var copyText = document.getElementById('userLink')
      /* Select the text field */
      copyText.select()
      /* Copy the text inside the text field */
      document.execCommand('copy')
    },
    sendInvite () {
      this.$validator.validate('inviteForm.*').then(() => {
        if (!this.errors.any()) {
          if (this.isLoading) return
          this.isLoading = true
          this.$store
            .dispatch('invitePatient', this.invite)
            .then(() => {
              $('.inviteModal').modal('hide')
              this.invite = {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                notes: ''
              }
            })
            .finally(() => {
              this.isLoading = false
            })
        }
      })
    },
    userCanImpersonate () {
      if (authService.canImpersonate()) {
        this.show = true
      }
    }
  }
}
</script>

<style lang="scss">
  body {
    color: #2d3033;
    background-color: white;

    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    -webkit-font-smoothing: antialiased;
  }

  header {
    background-color: white;
    border-bottom: 1px solid #e2e6e8;
  }

  .admin-toolbar {
    padding: 15px 0 10px;
    span {
      font-size: 13px;
      font-style: italic;
      font-weight: 300;
      color: #889096;
    }

    strong {
      font-weight: 400;
      font-style: normal;
      color: #2d3033;
    }
    .btn-group {
      margin-left: 10px;
    }

    .btn {
      font-family: 'Raleway', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 0.2px;
      font-weight: 700;
      font-weight: 500;
      line-height: 36px;
      height: 36px;
      padding: 0 15px;
      background-color: #f4f4f5;
      color: #2d3033;
      border-color: white;
      cursor: pointer;
    }
  }
  .branding {
    background: none;
    border-radius: 0;

    .branding__mark {
      margin-right: 15px;
      box-sizing: initial;
      padding: 15px;
      padding-right: 14px;
      padding-left: 0;
      max-height: 50px;
      border-right: 1px solid #e2e6e8;
    }

    .branding__title {
      padding-top: 30px;
      line-height: 44px;
      font-weight: 300;
      letter-spacing: 0.2px;
      font-family: 'Raleway', sans-serif;
      font-size: 18px;
    }
  }
  .portalTitle {
    font-size: 24px;
    font-weight: normal;
  }

  .main-nav {
    background: none;
    font-family: 'Raleway', sans-serif;
    height: 80px;
    padding: 18px 0;
    line-height: 44px;
    border-radius: 0;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    flex-wrap: nowrap;
    .main-nav button {
      margin-top: 50px !important;
      font-size: 12px;
      margin-left: 15px;
    }
    .nav-item .router-link-exact-active {
      color: #6c7279;
      display: block;
      align-self: flex-end;

      .router-link-exact-active::before {
        content: '';
        position: absolute;
        left: 50%;
        margin-left: -8px;
        top: 54px;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid #e2e6e8;
        clear: both;
      }
      .router-link-exact-active::after {
        content: '';
        position: absolute;
        left: 50%;
        margin-left: -8px;
        top: 55px;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid #f4f4f5;
        clear: both;
      }
    }
  }

  a {
    color: #ff8708;
    &:hover {
      color: #ff9c08;
    }
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .external-link {
      color: #00bfff;
      &:hover {
        color: #0084ff;
      }
    }

  .text-orange {
    color: #ff8708;
  }

  .btn-primary {
    background-color: #ff8708;
    border-color: #ff8708;
    &:hover {
      color: #fff !important;
      background: #ff9c08;
      border-color: #ff9c08;
    }
  }
  .inviteCustomer {
    margin-top: 10px;
  }
  .dropdown-item {
    font-weight: 100 !important;
    font-size: 14px;
  }

  .table {
    thead a {
      font-size: 14px;
      font-weight: bold;
    }
    tbody a {
      font-size: 14px;
      font-weight: 400;
      text-transform: none;
    }
  }

  .content-wrapper {
    background-color: #f4f4f5;

    h2 {
      font-size: 24px;
      font-weight: 300;
      margin: 0 0 20px;
      line-height: 1.2;
      color: inherit;
    }
  }
  h3 {
    font-size: 24px;
    font-weight: 300;
    margin: 0 0 20px;
    line-height: 1.2;
    color: inherit;
  }
  .content-dashboard {
    padding: 50px 0;

    .dashboard {
      background: white;
      margin: 0 0 40px;

      .dashboard__graph {
        background: white;
        border-radius: 3px 0 0 3px;
        padding: 30px 20px 20px;
      }
      .dashboard__payments {
        padding: 30px 20px;
        background: #568dbc url('~@/assets/images/background.png');
        border-radius: 0 3px 3px 0;
        background-repeat: no-repeat;
        background-size: auto;
        a {
          font-size: 1rem;
          font-weight: 400;
          text-transform: none;
        }
      }

      .dashboard__payments .dashboard__info.dashboard--primary {
        font-size: 16px;
      }

      .dashboard__payments .dashboard__info {
        display: block;
        margin: 0 0 20px;
        font-size: 14px;
        color: #fff;
      }

      .dashboard__payments .dashboard__info.dashboard--primary strong {
        font-size: 26px;
        font-weight: 700;
      }
      .dashboard__payments .dashboard__info strong {
        display: block;
        font-size: 16px;
        color: white;
        font-weight: 400;
      }
    }
  }

  table {
    thead {
      tr {
        background-color: #e2e6e8;
        th {
          padding-top: 8px !important;
          padding-bottom: 8px !important;
          text-transform: uppercase;
          font-size: 14px;
        }
      }
    }
    tbody {
      background-color: #fff;
      td {
        font-size: 14px;
      }
    }
  }

  footer {
    background: white;
    font-size: 14px;
    margin-top: -20px;

    .footer-nav {
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.2px;
      font-weight: 400;
      border-radius: 0 0 3px 3px;
      background-color: #889096;
      color: #fff;
      line-height: 20px;
      padding: 12px 20px;
      text-align: center;

      i {
        font-style: normal;
      }

      .footer-nav__link {
        display: inline-block;
        padding-top: 2px;
        color: white;
      }
    }

    .footer-info {
      padding: 60px 0;
      a {
        font-weight: 300;
        font-size: 14px;
        text-transform: none;
      }

      .socmed {
        text-align: right;

        .socmed__link {
          &.socmed--facebook {
            color: #4e70a8;
            border-color: rgba(78, 112, 168, 0.5);
            &:hover {
              background: #4e70a8;
              color: #fff;
            }
          }
          &.socmed--twitter {
            color: #01bbf2;
            border-color: rgba(1, 187, 242, 0.5);
            &:hover {
              background: #01bbf2;
              color: #fff;
            }
          }
          &.socmed--linkedin {
            color: #1587b1;
            border-color: rgba(21, 135, 177, 0.5);
            &:hover {
              background: #1587b1;
              color: #fff;
            }
          }
          &.socmed__link.socmed--youtube {
            color: #cb3736;
            border-color: rgba(203, 55, 54, 0.5);
            &:hover {
              background: #cb3736;
              color: #fff;
            }
          }
        }

        .socmed__link {
          display: block;
          border-radius: 50%;
          border: 1px solid red;
          width: 50px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 20px;
          transition: all 0.2s ease;
        }
      }

      h6 {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.2px;
        font-weight: 700;
        color: #a4aeb3;
        margin: 0 0 10px;
        font-weight: 300;
      }

      .contact {
        .contact__avatar {
          border-radius: 50%;
          border: 1px solid #c4ced1;
          margin-right: 20px;
          max-width: 80px;
          float: left;
        }
        .contact__title {
          margin: 0 0 10px;
          padding: 0;
          font-weight: 300;
        }
        .contact__name {
          margin: 15px 0 0;
          padding: 0;
          font-weight: 300;
        }
        .contact__description {
          display: block;
          color: #889096;
          font-weight: 300;
        }
        .contact__email {
          display: block;
          font-weight: 300;
        }
      }
    }
  }

  .footer-legals a {
    font-size: 14px;
    font-weight: 400;
    text-transform: none;
  }
  .badge {
    color: #fff !important;
  }
  .clickable {
    cursor: pointer;
  }
</style>
